import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export const usePayGrades = () => {
  const [payGrades, setPayGrades] = useState([]);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    axios.get(`${API}/api/employees/pay-grades`, { headers })
      .then(r => setPayGrades(r.data || []))
      .catch(() => setPayGrades([]))
      .finally(() => setLoading(false));
  }, []);

  return { payGrades, loading };
};
